/**
 * Giris formu dogrulamasi — Zod (frontend-vue skill: "manual/string-based
 * form validation FORBIDDEN"). Hata METINLERI burada uretilmez; view'ler
 * safeParse().success'e bakip kendi i18n anahtarlarini secer, cunku zod'un
 * yerlesik hata mesajlari yalniz Ingilizce/kendi locale eklentisiyle gelir
 * ve bu depo TR-EN anahtar paritesini (check-i18n-parity.mjs) tek kaynaktan
 * (locales/*.json) yonetir.
 */
import { z } from 'zod'

export const emailSchema = z.email()
export const passwordSchema = z.string().min(1)

export function isValidEmail(value: string): boolean {
  return emailSchema.safeParse(value.trim()).success
}

export function isValidPassword(value: string): boolean {
  return passwordSchema.safeParse(value).success
}

/**
 * FW-129 — kayit akisinin parola kurali, giris'in `passwordSchema`sindan
 * BILEREK AYRI: onayli tasarim (13-kayit-parola, durumlar.json `spec`)
 * "parola kurali 12+ / büyük harf / rakam" ister; giris ekrani sunucu
 * tarafinda da bir parola POLITIKASI UYGULAMAZ (mevcut hesaplar icin var
 * olan parolalar bu kurallardan once olusturulmus olabilir) — bu yuzden
 * `passwordSchema`/`isValidPassword` DEGISTIRILMEDI, PasswordView.vue'nun
 * davranisi BOZULMAZ.
 */
export const registrationPasswordRules = [
  { key: 'minLength', test: (value: string) => value.length >= 12 },
  { key: 'uppercase', test: (value: string) => /[A-Z]/.test(value) },
  { key: 'digit', test: (value: string) => /[0-9]/.test(value) },
] as const

export type RegistrationPasswordRuleKey = (typeof registrationPasswordRules)[number]['key']

export const registrationPasswordSchema = z
  .string()
  .min(12)
  .regex(/[A-Z]/)
  .regex(/[0-9]/)

export function isValidRegistrationPassword(value: string): boolean {
  return registrationPasswordSchema.safeParse(value).success
}

export interface PasswordRuleResult {
  readonly key: RegistrationPasswordRuleKey
  readonly satisfied: boolean
}

/**
 * 13-kayit-parola'nin canli kural listesi ("En az 12 karakter" / "Bir büyük
 * harf" / "Bir rakam") icin — her kuralin TEK TEK karsilanip karsilanmadigini
 * dondurur (RegisterPasswordView.vue bunu dogrudan render eder). `zod`'un
 * `safeParse` sonucu yalniz "hepsi gecti mi" soyler, hangi kuralin eksik
 * oldugunu degil — bu yuzden kurallar ayrica, TEK TEK degerlendirilir.
 */
export function evaluatePasswordRules(value: string): readonly PasswordRuleResult[] {
  return registrationPasswordRules.map((rule) => ({ key: rule.key, satisfied: rule.test(value) }))
}
